module.exports = __webpack_public_path__ + "static/img/pm_web_logo_13.4226133.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/pm_web_logo_13.png
// module id = nvrj
// module chunks = 0